export default __webpack_public_path__ + "static/assign-agent-38376f446dcffa5c45c57cee0c1e4694.png";